/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserCalculationsLastDatesResource { 
    userId: number | null;
    lastProperty: string | null;
    last60Percent: string | null;
    lastInvestment: string | null;
    lastMortgage: string | null;
}

